import React from 'react';
import ReactDOM from 'react-dom';

const FONT = { fontFamily: 'Archivo Expanded, Archivo, sans-serif', fontSize: '0.9rem' };

class LoginHistoryTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rows:         [],
            currentPage:  1,
            lastPage:     1,
            total:        0,
            loading:      true,
        };
        this.fetchPage = this.fetchPage.bind(this);
    }

    componentDidMount() {
        this.fetchPage(1);
    }

    fetchPage(page) {
        this.setState({ loading: true });
        axios.get(`/user/${this.props.userId}/login-history`, { params: { page } })
            .then(res => {
                const { data, current_page, last_page, total, per_page } = res.data;
                this.setState({
                    rows:        data,
                    currentPage: current_page,
                    lastPage:    last_page,
                    total,
                    loading:     false,
                    perPage:     per_page,
                });
            })
            .catch(() => this.setState({ loading: false }));
    }

    renderPagination() {
        const { currentPage, lastPage } = this.state;
        if (lastPage <= 1) return null;

        const pages = Array.from({ length: lastPage }, (_, i) => i + 1)
            .filter(p => p === 1 || p === lastPage || Math.abs(p - currentPage) <= 2)
            .reduce((acc, p, idx, arr) => {
                if (idx > 0 && p - arr[idx - 1] > 1) acc.push('…');
                acc.push(p);
                return acc;
            }, []);

        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap mt-2" style={{ gap: '8px' }}>
                <span style={{ ...FONT, fontSize: '16px', color: '#666' }}>
                    Página {currentPage} de {lastPage} &nbsp;&nbsp; {this.state.total} registros
                </span>
                <div className="lh-pagination">
                    {[
                        { label: '«', target: 1,               disabled: currentPage === 1 },
                        { label: '‹', target: currentPage - 1, disabled: currentPage === 1 },
                    ].map(({ label, target, disabled }) => (
                        <button key={label} className="lh-page-btn" disabled={disabled}
                            onClick={() => this.fetchPage(target)}>{label}</button>
                    ))}

                    {pages.map((p, i) => p === '…'
                        ? <span key={`e${i}`} className="lh-page-ellipsis">…</span>
                        : <button key={p}
                            className={`lh-page-btn${p === currentPage ? ' lh-page-btn--active' : ''}`}
                            onClick={() => p !== currentPage && this.fetchPage(p)}>{p}</button>
                    )}

                    {[
                        { label: '›', target: currentPage + 1, disabled: currentPage === lastPage },
                        { label: '»', target: lastPage,        disabled: currentPage === lastPage },
                    ].map(({ label, target, disabled }) => (
                        <button key={label} className="lh-page-btn" disabled={disabled}
                            onClick={() => this.fetchPage(target)}>{label}</button>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        const { rows, total, loading } = this.state;

        return (
            <div>
                <h3 className="mb-4" style={FONT}>
                    Histórico de Logins
                    <span className="ml-2 badge badge-secondary" style={{ fontSize: '14px', verticalAlign: 'middle' }}>
                        {total}
                    </span>
                </h3>

                {loading && (
                    <div className="text-center py-3" style={FONT}>
                        <i className="fa fa-spinner fa-spin"></i> Carregando...
                    </div>
                )}

                {!loading && (
                    <div style={{ overflowX: 'auto' }}>
                        <table className="table table-bordered table-sm table-striped lh-table">
                            <thead className="lh-thead">
                                <tr>
                                    {['#', 'Login', 'Última Atividade', 'Tempo de atividade', 'IP'].map(h => (
                                        <th key={h} style={FONT}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="text-center" style={FONT}>
                                            Nenhum acesso registrado
                                        </td>
                                    </tr>
                                ) : rows.map((row, i) => (
                                    <tr key={i}>
                                        <td style={FONT}>{((this.state.currentPage - 1) * this.state.perPage) + i + 1}</td>
                                        <td style={FONT}>{row.login}</td>
                                        <td style={FONT}>{row.ultima_atividade || '—'}</td>
                                        <td style={FONT}>{row.tempo_atividade || '—'}</td>
                                        <td style={FONT}>{row.ip || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {this.renderPagination()}
                    </div>
                )}
            </div>
        );
    }
}

const mountPoint = document.getElementById('js-login-history');
if (mountPoint) {
    const userId = mountPoint.dataset.userId;
    ReactDOM.render(<LoginHistoryTable userId={userId} />, mountPoint);
}
